<div
  class="bg-mib-app-background flex min-h-screen flex-col items-center justify-center gap-8 p-8 text-center">
  <svg mib-logo-medinbox class="h-11 not-height-medium:h-6 text-mib-branding-900"></svg>

  <div class="flex items-center justify-center rounded-full w-30 h-30 bg-mib-danger-surface">
    <div class="flex items-center justify-center rounded-full w-20 h-20 bg-mib-danger">
      <svg mib-icon name="circle-alert" class="size-11 text-white"></svg>
    </div>
  </div>

  <div class="flex flex-col gap-2 justify-center">
    <h1 class="text-2xl text-mib-branding-900">Sign-in refused</h1>
    <p class="max-w-md text-gray-500 first-letter:capitalize">{{ description() }}</p>
  </div>
  <button mibButton type="button" routerLink="/" class="w-50 py-8">Retry</button>
</div>
